import React, { useEffect, useRef, useState } from "react";
import styles from './Gallery.module.css';
import { imgArray2 } from "./ImgArray";
import GalleryElement from "./GalleryElement";
import TagContainer from "./TagContainer";

export default function Gallery(){

    const galleryRef = useRef(null);
    const [distinctTags,setDistinctTags] = useState([]);

    // useEffect(() => {   
    //     const images = galleryRef.current.querySelectorAll("img");

    //     images.forEach((img) => {
    //     if (img.complete) {
    //         setFlex(img);
    //     } else {
    //         img.onload = () => setFlex(img);
    //     }
    //     });

    //     function setFlex(image) {
    //         const ratio = image.naturalWidth / image.naturalHeight;
    //         const wrapper = image.parentElement;
    //         // wrapper.style.flex = `${ratio} 1`;
    //     }
    // }, []);


    useEffect(() => {  
        setDistinctTags(() => {
            let newArray = ['all'];
            imgArray2.forEach((imgObj) => {
                imgObj.tags.forEach((tag) => {
                    const index = newArray.findIndex((ele) => ele === tag);
                    if(index === -1){
                        newArray.push(tag);
                    }
                });
            });
            return newArray;
        });        
    },[imgArray2]);

    return (
        <main>
            <section className={styles.top}>
                <h1>Gallery</h1>
            </section>
            <div className={styles.tagContainer}>
                {distinctTags.map((tag) => <TagContainer tag={tag} imgArray={imgArray2}/>)}
            </div>
            {/* <section className={styles.largeWidth}>
                <div ref={galleryRef} className={styles.galleryGrid}>
                    {imgArray2.map((obj) => <GalleryElement imgObject={obj}/>)}
                </div>
            </section> */}
        </main>
    )
}